"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = void 0;
var _react = require("react");
const useResizeObserver = function () {
  let {
    defaultWidth = 0,
    defaultHeight = 0,
    defaultElement,
    borderBoxSize = false,
    shouldWaitForWindowFrame = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [element, setElement] = (0, _react.useState)();
  const [size, setSize] = (0, _react.useState)({
    width: defaultWidth,
    height: defaultHeight
  });

  // Dynamic ref will not rerender and reinitiate ResizeObserver
  // `setElement` is fixing this issue
  const ref = node => setElement(node);
  ref.current = element;
  const isDefaultElementChanged = defaultElement !== element;
  if (defaultElement && isDefaultElementChanged) {
    ref(defaultElement);
  }
  (0, _react.useEffect)(() => {
    if (!element) {
      return;
    }
    const resizeObserver = new ResizeObserver(entries => {
      if (!entries.length) {
        return;
      }
      const [entry] = entries;
      const updateElementSize = () => {
        if (borderBoxSize) {
          setSize({
            width: entry.borderBoxSize[0].inlineSize,
            height: entry.borderBoxSize[0].blockSize
          });
        } else {
          setSize({
            width: entry.contentRect.width,
            height: entry.contentRect.height
          });
        }
      };
      if (shouldWaitForWindowFrame) {
        window.requestAnimationFrame(updateElementSize);
      } else {
        updateElementSize();
      }
    });
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  }, [element, borderBoxSize, shouldWaitForWindowFrame]);
  return {
    ref: ref,
    ...size
  };
};
exports.useResizeObserver = useResizeObserver;